import React, { Fragment } from 'react'

import classNames from 'classnames'

import { useMutation, useQuery } from '@apollo/client'
import { Trans } from '@lingui/macro'
import Loading from 'Root/Loader/Page'
import map from 'lodash/map'

import QUERY from './current-user-folders.graphql'
import MUTATION from './toggle-collection-folder-association.graphql'

export interface Props {
  id: string
}

const AssociateToFolders: React.FC<Props> = ({ id }: Props) => {
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      includes: id,
    },
  })

  const [mutate, { loading: isMutating }] = useMutation(MUTATION, {
    refetchQueries: ['GetUserBoards', 'FolderPage'],
  })

  if (loading) {
    return <Loading />
  }

  const allFolders = data?.me?.userFolders || []
  // Filter out parent folders (where includes is true but hasAssociation is false)
  const folders = allFolders.filter(
    (folder) => !(folder.includes === true && folder.hasAssociation === false)
  )

  const onChange = (folder) => async (event) => {
    const checked = event.target.checked

    await mutate({
      variables: {
        collectionId: id,
        folderId: folder.id,
        associated: checked,
      },
    })
  }

  return (
    <Fragment>
      <div className="text-2xl border-b border-gray-300 p-2">
        <Trans>Bacheche associate a questo corso/collezione</Trans>
      </div>
      <ul className="divide-y divide-gray-200">
        {map(folders, (folder) => (
          <li key={folder.id} className="p-4">
            <label
              className={classNames(
                {
                  'opacity-50': isMutating,
                },
                'inline-flex items-center cursor-pointer'
              )}
            >
              <input
                className="cursor-pointer form-checkbox h-8 w-8 rounded-md border-gray-300 p-4"
                defaultChecked={folder.hasAssociation}
                onChange={onChange(folder)}
                type="checkbox"
                disabled={isMutating}
              />
              <span className="ml-4 text-xl">{folder.title}</span>
            </label>
          </li>
        ))}
      </ul>
    </Fragment>
  )
}

export default AssociateToFolders
